/* 動画紹介セクション：リストをクリックするとメイン動画を切り替える */
(function () {
  'use strict';

  function init(root) {
    if (root.__videoShowcase) return;
    root.__videoShowcase = true;

    const iframe = root.querySelector('[data-video-iframe]');
    const items = Array.from(root.querySelectorAll('[data-video-item]'));
    if (!iframe || items.length === 0) return;

    items.forEach((item) => {
      item.addEventListener('click', () => {
        const id = item.dataset.youtubeId;
        if (!id) return;
        iframe.src = `https://www.youtube.com/embed/${id}?rel=0&playsinline=1&autoplay=1`;

        items.forEach((i) => {
          i.classList.toggle('is-active', i === item);
          i.setAttribute('aria-pressed', i === item ? 'true' : 'false');
        });

        // 縦並びのときはメイン動画まで戻す
        if (window.innerWidth < 990) {
          const main = root.querySelector('.video-showcase__main');
          if (main) main.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-video-showcase]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
